import React, { useState, useEffect, useMemo } from "react";
import { Search, X } from "lucide-react";
import "../../apps/components/SmartLibrary.css";

// ─────────────────────────────────────────────────────────────────────────────
// COMPLETE 26-DOMAIN SEED DATA
// ─────────────────────────────────────────────────────────────────────────────
export const SEED_DATA = {
  "Artificial Intelligence": {
    Easy: [
      { title: "Artificial Intelligence: A Guide for Thinking Humans", author: "Melanie Mitchell" },
      { title: "AI Superpowers", author: "Kai-Fu Lee" },
      { title: "The Master Algorithm", author: "Pedro Domingos" },
      { title: "Life 3.0", author: "Max Tegmark" },
      { title: "Machine Learning for Absolute Beginners", author: "Oliver Theobald" },
      { title: "Data Science for Business", author: "Foster Provost, Tom Fawcett" },
      { title: "Grokking Deep Learning", author: "Andrew Trask" },
      { title: "The Hundred-Page Machine Learning Book", author: "Andriy Burkov" },
      { title: "Artificial Intelligence Basics", author: "Tom Taulli" },
    ],
    Medium: [
      { title: "Artificial Intelligence: A Modern Approach", author: "Stuart Russell, Peter Norvig" },
      { title: "Deep Learning", author: "Ian Goodfellow, Yoshua Bengio, Aaron Courville" },
      { title: "Pattern Recognition and Machine Learning", author: "Christopher Bishop" },
      { title: "Reinforcement Learning: An Introduction", author: "Richard Sutton, Andrew Barto" },
      { title: "Human Compatible", author: "Stuart Russell" },
      { title: "Natural Language Processing with Transformers", author: "Lewis Tunstall et al." },
      { title: "Designing Machine Learning Systems", author: "Chip Huyen" },
    ],
    Hard: [
      { title: "Information Theory, Inference, and Learning Algorithms", author: "David MacKay" },
      { title: "The Elements of Statistical Learning", author: "Hastie, Tibshirani, Friedman" },
      { title: "Bayesian Reasoning and Machine Learning", author: "David Barber" },
      { title: "Mathematics for Machine Learning", author: "Deisenroth, Faisal, Ong" },
      { title: "Causal Inference in Statistics", author: "Judea Pearl" },
      { title: "The Society of Mind", author: "Marvin Minsky" },
      { title: "Large Language Models", author: "Sebastian Raschka" },
    ],
  },
  "Biology": {
    Easy: [
      { title: "The Selfish Gene", author: "Richard Dawkins" },
      { title: "The Blind Watchmaker", author: "Richard Dawkins" },
      { title: "The Double Helix", author: "James Watson" },
      { title: "The Gene: An Intimate History", author: "Siddhartha Mukherjee" },
      { title: "I Contain Multitudes", author: "Ed Yong" },
      { title: "Genome", author: "Matt Ridley" },
      { title: "Why Evolution Is True", author: "Jerry Coyne" },
      { title: "The Immortal Life of Henrietta Lacks", author: "Rebecca Skloot" },
    ],
    Medium: [
      { title: "The Origin of Species", author: "Charles Darwin" },
      { title: "Essential Cell Biology", author: "Bruce Alberts et al." },
      { title: "The Vital Question", author: "Nick Lane" },
      { title: "The Epigenetics Revolution", author: "Nessa Carey" },
      { title: "Power, Sex, Suicide: Mitochondria", author: "Nick Lane" },
    ],
    Hard: [
      { title: "Molecular Biology of the Cell", author: "Bruce Alberts et al." },
      { title: "Campbell Biology", author: "Neil Campbell et al." },
      { title: "Human Physiology: From Cells to Systems", author: "Lauralee Sherwood" },
      { title: "Microbiology: An Introduction", author: "Gerard Tortora et al." },
    ],
  },
  "Chemistry": {
    Easy: [
      { title: "The Disappearing Spoon", author: "Sam Kean" },
      { title: "The Periodic Table", author: "Primo Levi" },
      { title: "The Elements", author: "Theodore Gray" },
      { title: "Napoleon's Buttons", author: "Penny Le Couteur, Jay Burreson" },
      { title: "Stuff Matters", author: "Mark Miodownik" },
      { title: "Uncle Tungsten", author: "Oliver Sacks" },
      { title: "Periodic Tales", author: "Hugh Aldersey-Williams" },
    ],
    Medium: [
      { title: "Chemistry: The Central Science", author: "Theodore Brown et al." },
      { title: "Why Chemical Reactions Happen", author: "James Keeler, Peter Wothers" },
      { title: "Chemical Principles", author: "Peter Atkins" },
    ],
    Hard: [
      { title: "Organic Chemistry", author: "Jonathan Clayden et al." },
      { title: "Physical Chemistry", author: "Peter Atkins, Julio de Paula" },
      { title: "Biochemistry", author: "Jeremy Berg et al." },
      { title: "Inorganic Chemistry", author: "Gary Miessler et al." },
    ],
  },
  "Computer Science": {
    Easy: [
      { title: "Code: The Hidden Language of Computer Hardware and Software", author: "Charles Petzold" },
      { title: "Automate the Boring Stuff with Python", author: "Al Sweigart" },
      { title: "The Innovators", author: "Walter Isaacson" },
      { title: "Algorithms to Live By", author: "Brian Christian, Tom Griffiths" },
      { title: "Hackers: Heroes of the Computer Revolution", author: "Steven Levy" },
    ],
    Medium: [
      { title: "Clean Code", author: "Robert C. Martin" },
      { title: "The Mythical Man-Month", author: "Frederick Brooks" },
      { title: "The Pragmatic Programmer", author: "Andrew Hunt, David Thomas" },
      { title: "Design Patterns", author: "Erich Gamma et al." },
      { title: "Computer Systems: A Programmer's Perspective", author: "Bryant, O'Hallaron" },
    ],
    Hard: [
      { title: "Introduction to Algorithms (CLRS)", author: "Cormen, Leiserson, Rivest, Stein" },
      { title: "Structure and Interpretation of Computer Programs (SICP)", author: "Abelson, Sussman" },
      { title: "The Art of Computer Programming", author: "Donald Knuth" },
      { title: "Compilers: Principles, Techniques, and Tools", author: "Aho, Lam, Sethi, Ullman" },
    ],
  },
  "Dentistry": {
    Easy: [
      { title: "Teeth: The Story of Beauty, Inequality, and the Struggle for Oral Health", author: "Mary Otto" },
      { title: "The Smile Stealers", author: "Richard Barnett" },
      { title: "Open Wide: A Radically Real Guide to Deeply Loving Your Life", author: "Melissa Ambrosini" },
    ],
    Medium: [
      { title: "Pickard's Guide to Minimally Invasive Operative Dentistry", author: "Avijit Banerjee, Timothy Watson" },
      { title: "Wheeler's Dental Anatomy, Physiology and Occlusion", author: "Stanley Nelson" },
      { title: "Clinical Problem Solving in Dentistry", author: "Odell" },
    ],
    Hard: [
      { title: "Carranza's Clinical Periodontology", author: "Michael Newman et al." },
      { title: "Contemporary Oral and Maxillofacial Surgery", author: "James Hupp et al." },
      { title: "Cohen's Pathways of the Pulp", author: "Kenneth Hargreaves, Louis Berman" },
      { title: "Ten Cate's Oral Histology", author: "Antonio Nanci" },
    ],
  },
  "Economics": {
    Easy: [
      { title: "Freakonomics", author: "Steven Levitt, Stephen Dubner" },
      { title: "Thinking, Fast and Slow", author: "Daniel Kahneman" },
      { title: "The Undercover Economist", author: "Tim Harford" },
      { title: "Nudge", author: "Richard Thaler, Cass Sunstein" },
      { title: "Economics in One Lesson", author: "Henry Hazlitt" },
      { title: "Poor Economics", author: "Abhijit Banerjee, Esther Duflo" },
    ],
    Medium: [
      { title: "Principles of Economics", author: "N. Gregory Mankiw" },
      { title: "Capital in the Twenty-First Century", author: "Thomas Piketty" },
      { title: "The Wealth of Nations", author: "Adam Smith" },
      { title: "Misbehaving: The Making of Behavioral Economics", author: "Richard Thaler" },
      { title: "Intermediate Microeconomics", author: "Hal Varian" },
    ],
    Hard: [
      { title: "Microeconomic Theory", author: "Mas-Colell, Whinston, Green" },
      { title: "Advanced Macroeconomics", author: "David Romer" },
      { title: "The General Theory of Employment, Interest and Money", author: "John Maynard Keynes" },
      { title: "Recursive Methods in Economic Dynamics", author: "Stokey, Lucas, Prescott" },
    ],
  },
  "Econophysics": {
    Easy: [
      { title: "The Physics of Wall Street", author: "James Owen Weatherall" },
      { title: "More Heat than Light", author: "Philip Mirowski" },
      { title: "The Misbehavior of Markets", author: "Benoit Mandelbrot" },
    ],
    Medium: [
      { title: "Introduction to Econophysics: Correlations and Complexity in Finance", author: "Rosario Mantegna, H. Eugene Stanley" },
      { title: "Theory of Financial Risk and Derivative Pricing", author: "Jean-Philippe Bouchaud, Marc Potters" },
      { title: "Econophysics: An Introduction", author: "Sinha, Sitabhra et al." },
    ],
    Hard: [
      { title: "Quantum Finance", author: "Emmanuel Haven, Andrei Khrennikov" },
      { title: "Statistical Mechanics of Financial Markets", author: "Johannes Voit" },
      { title: "Nonlinear Dynamics and Chaos in Economics", author: "Cars Hommes" },
    ],
  },
  "Engineering": {
    Easy: [
      { title: "To Engineer Is Human", author: "Henry Petroski" },
      { title: "The Design of Everyday Things", author: "Don Norman" },
      { title: "Skunk Works", author: "Ben Rich, Leo Janos" },
      { title: "The Existential Pleasures of Engineering", author: "Samuel Florman" },
      { title: "Structures: Or Why Things Don't Fall Down", author: "J.E. Gordon" },
    ],
    Medium: [
      { title: "Shigley's Mechanical Engineering Design", author: "Budynas, Nisbett" },
      { title: "Engineering Mechanics: Statics & Dynamics", author: "Russell Hibbeler" },
      { title: "Fundamentals of Electric Circuits", author: "Charles Alexander, Matthew Sadiku" },
    ],
    Hard: [
      { title: "Fundamentals of Heat and Mass Transfer", author: "Bergman, Lavine, Incropera, DeWitt" },
      { title: "Modern Control Engineering", author: "Katsuhiko Ogata" },
      { title: "Fluid Mechanics", author: "Frank White" },
      { title: "Mechanics of Materials", author: "James Gere, Barry Goodno" },
    ],
  },
  "English Literature": {
    Easy: [
      { title: "How to Read Literature Like a Professor", author: "Thomas C. Foster" },
      { title: "A Room of One's Own", author: "Virginia Woolf" },
      { title: "The Great Gatsby", author: "F. Scott Fitzgerald" },
      { title: "1984", author: "George Orwell" },
      { title: "Pride and Prejudice", author: "Jane Austen" },
      { title: "To Kill a Mockingbird", author: "Harper Lee" },
    ],
    Medium: [
      { title: "The Norton Anthology of English Literature", author: "Stephen Greenblatt et al." },
      { title: "Literary Theory: An Introduction", author: "Terry Eagleton" },
      { title: "Ulysses", author: "James Joyce" },
      { title: "Hamlet", author: "William Shakespeare" },
      { title: "The Waste Land", author: "T.S. Eliot" },
    ],
    Hard: [
      { title: "Finnegans Wake", author: "James Joyce" },
      { title: "The Anatomy of Criticism", author: "Northrop Frye" },
      { title: "The Western Canon", author: "Harold Bloom" },
      { title: "Mimesis: The Representation of Reality in Western Literature", author: "Erich Auerbach" },
    ],
  },
  "Geography": {
    Easy: [
      { title: "Prisoners of Geography", author: "Tim Marshall" },
      { title: "The Revenge of Geography", author: "Robert D. Kaplan" },
      { title: "Guns, Germs, and Steel", author: "Jared Diamond" },
      { title: "Maphead", author: "Ken Jennings" },
      { title: "The Power of Geography", author: "Tim Marshall" },
    ],
    Medium: [
      { title: "Geopolitics: The Geography of International Relations", author: "Saul Bernard Cohen" },
      { title: "Physical Geography: A Landscape Appreciation", author: "Tom McKnight, Darrel Hess" },
      { title: "Human Geography: People, Place, and Culture", author: "Erin Fouberg et al." },
    ],
    Hard: [
      { title: "Spatial Analysis and Modeling in Geographical Transformation Process", author: "Yuji Murayama" },
      { title: "Geomorphology: The Mechanics and Chemistry of Landscapes", author: "Robert Anderson, Suzanne Anderson" },
      { title: "Applied Climatology: Principles and Practice", author: "Russell Thompson, Allen Perry" },
    ],
  },
  "Investment Banking": {
    Easy: [
      { title: "Liar's Poker", author: "Michael Lewis" },
      { title: "Monkey Business: Swinging Through the Wall Street Jungle", author: "John Rolfe, Peter Troob" },
      { title: "Barbarians at the Gate", author: "Bryan Burrough, John Helyar" },
      { title: "Too Big to Fail", author: "Andrew Ross Sorkin" },
      { title: "The Big Short", author: "Michael Lewis" },
    ],
    Medium: [
      { title: "Investment Banking: Valuation, LBOs, M&A", author: "Joshua Rosenbaum, Joshua Pearl" },
      { title: "Damodaran on Valuation", author: "Aswath Damodaran" },
      { title: "Financial Modeling and Valuation", author: "Paul Pignataro" },
      { title: "The Little Book of Valuation", author: "Aswath Damodaran" },
    ],
    Hard: [
      { title: "Options, Futures, and Other Derivatives", author: "John C. Hull" },
      { title: "Principles of Corporate Finance", author: "Richard Brealey, Stewart Myers, Franklin Allen" },
      { title: "Corporate Finance", author: "Jonathan Berk, Peter DeMarzo" },
      { title: "Applied Mergers and Acquisitions", author: "Robert Bruner" },
    ],
  },
  "Law": {
    Easy: [
      { title: "Letters to a Law Student", author: "Nicholas McBride" },
      { title: "The Rule of Law", author: "Tom Bingham" },
      { title: "What About Law?", author: "Catherine Barnard, Janet O'Sullivan, Graham Virgo" },
      { title: "Just Mercy", author: "Bryan Stevenson" },
      { title: "Learning the Law", author: "Glanville Williams" },
      { title: "The Secret Barrister", author: "The Secret Barrister" },
    ],
    Medium: [
      { title: "The Concept of Law", author: "H.L.A. Hart" },
      { title: "Taking Rights Seriously", author: "Ronald Dworkin" },
      { title: "Constitutional Law: Principles and Policies", author: "Erwin Chemerinsky" },
      { title: "Unjust Enrichment", author: "Peter Birks" },
      { title: "An Introduction to the Law of Contract", author: "P.S. Atiyah" },
    ],
    Hard: [
      { title: "Pure Theory of Law", author: "Hans Kelsen" },
      { title: "Law's Empire", author: "Ronald Dworkin" },
      { title: "The Province of Jurisprudence Determined", author: "John Austin" },
      { title: "The Authority of Law", author: "Joseph Raz" },
    ],
  },
  "Medicine": {
    Easy: [
      { title: "When Breath Becomes Air", author: "Paul Kalanithi" },
      { title: "Being Mortal", author: "Atul Gawande" },
      { title: "The Emperor of All Maladies", author: "Siddhartha Mukherjee" },
      { title: "Do No Harm: Stories of Life, Death and Brain Surgery", author: "Henry Marsh" },
      { title: "The Man Who Mistook His Wife for a Hat", author: "Oliver Sacks" },
      { title: "This Is Going to Hurt", author: "Adam Kay" },
    ],
    Medium: [
      { title: "Harrison's Principles of Internal Medicine", author: "Dennis Kasper et al." },
      { title: "Robbins & Cotran Pathologic Basis of Disease", author: "Vinay Kumar et al." },
      { title: "First Aid for the USMLE Step 1", author: "Tao Le, Vikas Bhushan" },
      { title: "Guyton and Hall Textbook of Medical Physiology", author: "John E. Hall" },
    ],
    Hard: [
      { title: "Oxford Textbook of Medicine", author: "David Warrell et al." },
      { title: "Goodman & Gilman's The Pharmacological Basis of Therapeutics", author: "Laurence Brunton et al." },
      { title: "Braunwald's Heart Disease", author: "Douglas Mann et al." },
      { title: "Schwartz's Principles of Surgery", author: "F. Charles Brunicardi et al." },
    ],
  },
  "Medical Ethics": {
    Easy: [
      { title: "Medical Ethics: A Very Short Introduction", author: "Tony Hope" },
      { title: "The Immortal Life of Henrietta Lacks", author: "Rebecca Skloot" },
      { title: "Bioethics: An Introduction", author: "Marianne Talbot" },
    ],
    Medium: [
      { title: "Principles of Biomedical Ethics", author: "Tom Beauchamp, James Childress" },
      { title: "A Companion to Bioethics", author: "Helga Kuhse, Peter Singer" },
      { title: "Contemporary Issues in Bioethics", author: "Tom Beauchamp, LeRoy Walters" },
    ],
    Hard: [
      { title: "The Foundations of Bioethics", author: "H. Tristram Engelhardt Jr." },
      { title: "Autonomy and Trust in Bioethics", author: "Onora O'Neill" },
      { title: "Life's Dominion: An Argument About Abortion, Euthanasia, and Individual Freedom", author: "Ronald Dworkin" },
    ],
  },
  "Management Consulting": {
    Easy: [
      { title: "The McKinsey Way", author: "Ethan Rasiel" },
      { title: "Case in Point", author: "Marc Cosentino" },
      { title: "The Pyramid Principle", author: "Barbara Minto" },
      { title: "Lords of Strategy", author: "Walter Kiechel III" },
      { title: "Case Interview Secrets", author: "Victor Cheng" },
    ],
    Medium: [
      { title: "Competitive Strategy", author: "Michael E. Porter" },
      { title: "Playing to Win: How Strategy Really Works", author: "A.G. Lafley, Roger L. Martin" },
      { title: "Good Strategy Bad Strategy", author: "Richard Rumelt" },
      { title: "The Innovator's Dilemma", author: "Clayton Christensen" },
    ],
    Hard: [
      { title: "Strategy Safari", author: "Henry Mintzberg, Bruce Ahlstrand, Joseph Lampel" },
      { title: "Co-opetition", author: "Adam Brandenburger, Barry Nalebuff" },
      { title: "Corporate Strategy", author: "Richard Lynch" },
    ],
  },
  "Mathematics": {
    Easy: [
      { title: "Fermat's Enigma", author: "Simon Singh" },
      { title: "How Not to Be Wrong: The Power of Mathematical Thinking", author: "Jordan Ellenberg" },
      { title: "The Joy of x", author: "Steven Strogatz" },
      { title: "Gödel, Escher, Bach", author: "Douglas Hofstadter" },
      { title: "A Mathematician's Apology", author: "G.H. Hardy" },
    ],
    Medium: [
      { title: "Linear Algebra and Its Applications", author: "Gilbert Strang" },
      { title: "Calculus", author: "Michael Spivak" },
      { title: "Real Analysis: Modern Techniques and Their Applications", author: "Gerald Folland" },
      { title: "Concrete Mathematics", author: "Ronald Graham, Donald Knuth, Oren Patashnik" },
    ],
    Hard: [
      { title: "Principles of Mathematical Analysis (Baby Rudin)", author: "Walter Rudin" },
      { title: "Abstract Algebra", author: "David Dummit, Richard Foote" },
      { title: "Topology", author: "James Munkres" },
      { title: "Complex Analysis", author: "Lars Ahlfors" },
    ],
  },
  "Philosophy": {
    Easy: [
      { title: "Think: A Compelling Introduction to Philosophy", author: "Simon Blackburn" },
      { title: "Sophie's World", author: "Jostein Gaarder" },
      { title: "Justice: What's the Right Thing to Do?", author: "Michael Sandel" },
      { title: "The Problems of Philosophy", author: "Bertrand Russell" },
      { title: "Meditations", author: "Marcus Aurelius" },
      { title: "At the Existentialist Café", author: "Sarah Bakewell" },
    ],
    Medium: [
      { title: "The Republic", author: "Plato" },
      { title: "Meditations on First Philosophy", author: "René Descartes" },
      { title: "Nicomachean Ethics", author: "Aristotle" },
      { title: "An Enquiry Concerning Human Understanding", author: "David Hume" },
      { title: "Utilitarianism", author: "John Stuart Mill" },
    ],
    Hard: [
      { title: "Critique of Pure Reason", author: "Immanuel Kant" },
      { title: "Being and Time", author: "Martin Heidegger" },
      { title: "Tractatus Logico-Philosophicus", author: "Ludwig Wittgenstein" },
      { title: "Phenomenology of Spirit", author: "G.W.F. Hegel" },
    ],
  },
  "Physics": {
    Easy: [
      { title: "A Brief History of Time", author: "Stephen Hawking" },
      { title: "Six Easy Pieces", author: "Richard Feynman" },
      { title: "Seven Brief Lessons on Physics", author: "Carlo Rovelli" },
      { title: "Astrophysics for People in a Hurry", author: "Neil deGrasse Tyson" },
      { title: "The Elegant Universe", author: "Brian Greene" },
    ],
    Medium: [
      { title: "The Feynman Lectures on Physics", author: "Richard Feynman" },
      { title: "University Physics", author: "Young, Freedman" },
      { title: "Introduction to Electrodynamics", author: "David J. Griffiths" },
      { title: "Classical Mechanics", author: "John R. Taylor" },
    ],
    Hard: [
      { title: "Gravitation", author: "Misner, Thorne, Wheeler" },
      { title: "Classical Electrodynamics", author: "John David Jackson" },
      { title: "Statistical Mechanics", author: "R.K. Pathria, Paul Beale" },
      { title: "Quantum Field Theory in a Nutshell", author: "A. Zee" },
    ],
  },
  "Politics": {
    Easy: [
      { title: "Why Nations Fail", author: "Daron Acemoglu, James A. Robinson" },
      { title: "How Democracies Die", author: "Steven Levitsky, Daniel Ziblatt" },
      { title: "The Prince", author: "Niccolò Machiavelli" },
      { title: "On Tyranny", author: "Timothy Snyder" },
      { title: "The Dictator's Handbook", author: "Bruce Bueno de Mesquita, Alastair Smith" },
    ],
    Medium: [
      { title: "Leviathan", author: "Thomas Hobbes" },
      { title: "The Origins of Political Order", author: "Francis Fukuyama" },
      { title: "Two Treatises of Government", author: "John Locke" },
      { title: "Democracy in America", author: "Alexis de Tocqueville" },
    ],
    Hard: [
      { title: "The Social Contract", author: "Jean-Jacques Rousseau" },
      { title: "Politics Among Nations", author: "Hans Morgenthau" },
      { title: "Theory of International Politics", author: "Kenneth Waltz" },
      { title: "Political Order and Political Decay", author: "Francis Fukuyama" },
    ],
  },
  "Quantum Mechanics": {
    Easy: [
      { title: "Quantum: Einstein, Bohr, and the Great Debate About the Nature of Reality", author: "Manjit Kumar" },
      { title: "In Search of Schrödinger's Cat", author: "John Gribbin" },
      { title: "How the Hippies Saved Physics", author: "David Kaiser" },
    ],
    Medium: [
      { title: "Introduction to Quantum Mechanics", author: "David J. Griffiths, Darrell Schroeter" },
      { title: "Quantum Mechanics: The Theoretical Minimum", author: "Leonard Susskind, Art Friedman" },
      { title: "Principles of Quantum Mechanics", author: "R. Shankar" },
    ],
    Hard: [
      { title: "Modern Quantum Mechanics", author: "J.J. Sakurai, Jim Napolitano" },
      { title: "Quantum Mechanics and Path Integrals", author: "Richard Feynman, Albert Hibbs" },
      { title: "The Quantum Theory of Fields", author: "Steven Weinberg" },
    ],
  },
  "Robotics": {
    Easy: [
      { title: "Robot: Mere Machine to Transcendent Mind", author: "Hans Moravec" },
      { title: "Wired for War", author: "P.W. Singer" },
      { title: "Robotics: A Very Short Introduction", author: "Alan Winfield" },
    ],
    Medium: [
      { title: "Introduction to Autonomous Mobile Robots", author: "Roland Siegwart et al." },
      { title: "Robotics, Vision and Control", author: "Peter Corke" },
      { title: "Modern Robotics: Mechanics, Planning, and Control", author: "Kevin Lynch, Frank Park" },
    ],
    Hard: [
      { title: "Probabilistic Robotics", author: "Sebastian Thrun, Wolfram Burgard, Dieter Fox" },
      { title: "Planning Algorithms", author: "Steven LaValle" },
      { title: "A Mathematical Introduction to Robotic Manipulation", author: "Murray, Li, Sastry" },
    ],
  },
  "Data Science": {
    Easy: [
      { title: "Storytelling with Data", author: "Cole Nussbaumer Knaflic" },
      { title: "Naked Statistics", author: "Charles Wheelan" },
      { title: "Data Science from Scratch", author: "Joel Grus" },
    ],
    Medium: [
      { title: "Python for Data Analysis", author: "Wes McKinney" },
      { title: "Hands-On Machine Learning with Scikit-Learn, Keras, and TensorFlow", author: "Aurélien Géron" },
      { title: "Practical Statistics for Data Scientists", author: "Peter Bruce, Andrew Bruce, Peter Gedeck" },
    ],
    Hard: [
      { title: "Feature Engineering and Selection", author: "Max Kuhn, Kjell Johnson" },
      { title: "High-Dimensional Data Analysis", author: "Subhash Sharma" },
      { title: "Mining of Massive Datasets", author: "Jure Leskovec, Anand Rajaraman, Jeffrey Ullman" },
    ],
  },
  "Econometrics": {
    Easy: [
      { title: "Mastering 'Metrics: The Path from Cause to Effect", author: "Joshua Angrist, Jörn-Steffen Pischke" },
      { title: "Mostly Harmless Econometrics", author: "Joshua Angrist, Jörn-Steffen Pischke" },
      { title: "The Book of Why", author: "Judea Pearl, Dana Mackenzie" },
    ],
    Medium: [
      { title: "Introductory Econometrics: A Modern Approach", author: "Jeffrey Wooldridge" },
      { title: "Econometric Analysis of Cross Section and Panel Data", author: "Jeffrey Wooldridge" },
      { title: "Basic Econometrics", author: "Damodar Gujarati" },
    ],
    Hard: [
      { title: "Econometric Analysis", author: "William H. Greene" },
      { title: "Time Series Analysis", author: "James D. Hamilton" },
      { title: "Microeconometrics: Methods and Applications", author: "A. Colin Cameron, Pravin Trivedi" },
    ],
  },
  "History": {
    Easy: [
      { title: "Sapiens: A Brief History of Humankind", author: "Yuval Noah Harari" },
      { title: "Guns, Germs, and Steel", author: "Jared Diamond" },
      { title: "The Silk Roads: A New History of the World", author: "Peter Frankopan" },
      { title: "A Little History of the World", author: "E.H. Gombrich" },
      { title: "SPQR: A History of Ancient Rome", author: "Mary Beard" },
    ],
    Medium: [
      { title: "The Pursuit of Power: Europe 1815-1914", author: "Richard J. Evans" },
      { title: "Postwar: A History of Europe Since 1945", author: "Tony Judt" },
      { title: "The Mediterranean and the Mediterranean World", author: "Fernand Braudel" },
    ],
    Hard: [
      { title: "The Structure of Evolutionary Theory", author: "Stephen Jay Gould" },
      { title: "The Making of the English Working Class", author: "E.P. Thompson" },
      { title: "A Study of History", author: "Arnold Toynbee" },
    ],
  },
  "International Relations": {
    Easy: [
      { title: "World Order", author: "Henry Kissinger" },
      { title: "Diplomacy", author: "Henry Kissinger" },
      { title: "The Tragedy of Great Power Politics", author: "John Mearsheimer" },
    ],
    Medium: [
      { title: "Man, the State, and War", author: "Kenneth Waltz" },
      { title: "After Hegemony", author: "Robert Keohane" },
      { title: "Social Theory of International Politics", author: "Alexander Wendt" },
    ],
    Hard: [
      { title: "Power and Interdependence", author: "Robert Keohane, Joseph Nye" },
      { title: "Theory of International Politics", author: "Kenneth Waltz" },
      { title: "The Twenty Years' Crisis, 1919-1939", author: "E.H. Carr" },
    ],
  },
  "Statistics": {
    Easy: [
      { title: "The Signal and the Noise", author: "Nate Silver" },
      { title: "How to Lie with Statistics", author: "Darrell Huff" },
      { title: "The Drunkard's Walk", author: "Leonard Mlodinow" },
      { title: "The Lady Tasting Tea", author: "David Salsburg" },
    ],
    Medium: [
      { title: "Statistical Inference", author: "George Casella, Roger Berger" },
      { title: "Probability and Statistics", author: "Morris DeGroot, Mark Schervish" },
      { title: "All of Statistics", author: "Larry Wasserman" },
    ],
    Hard: [
      { title: "Mathematical Statistics: Basic Ideas and Selected Topics", author: "Bickel, Doksum" },
      { title: "Asymptotic Statistics", author: "A.W. van der Vaart" },
      { title: "Theory of Point Estimation", author: "E.L. Lehmann, George Casella" },
    ],
  },
};

export function getBookCoverStyle(title, domain) {
  let hash = 0;
  const str = (title || "") + (domain || "");
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % 8;

  // Ink, surface and cream covers, with one terracotta cover in eight.
  const ink = { bg: "var(--iv-band)", color: "var(--iv-on-band)" };
  const surface = { bg: "var(--iv-surface)", color: "var(--iv-head)" };
  const cream = { bg: "var(--iv-raised)", color: "var(--iv-head)", border: "1px solid var(--iv-line)" };
  const terracotta = { bg: "var(--iv-accent)", color: "var(--iv-btn-fg)" };
  const coverStyles = [ink, surface, cream, ink, surface, cream, ink, terracotta];

  return coverStyles[index];
}

const PIN_STORAGE_KEY = "smart_library_pins_v2";

export default function SmartLibrarySection({ onCreateNote }) {
  const [selectedDomain, setSelectedDomain] = useState("Artificial Intelligence");
  const [selectedLevel, setSelectedLevel] = useState("Easy");
  const [search, setSearch] = useState("");
  const [view, setView] = useState("library"); // "library" | "mybooks"
  const [pinned, setPinned] = useState(() => {
    try {
      const s = localStorage.getItem(PIN_STORAGE_KEY);
      return s ? JSON.parse(s) : [];
    } catch {
      return [];
    }
  });

  const [selectedBook, setSelectedBook] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailCache, setDetailCache] = useState({});
  const [generatingMore, setGeneratingMore] = useState(false);
  const [extraBooks, setExtraBooks] = useState({});

  useEffect(() => {
    try {
      localStorage.setItem(PIN_STORAGE_KEY, JSON.stringify(pinned));
    } catch {}
  }, [pinned]);

  const domainList = useMemo(() => Object.keys(SEED_DATA), []);

  const filteredDomains = useMemo(() => {
    if (!search.trim()) return domainList;
    const q = search.toLowerCase();
    return domainList.filter((d) => d.toLowerCase().includes(q));
  }, [domainList, search]);

  const allBooksForSelectedDomain = useMemo(() => {
    const domainData = SEED_DATA[selectedDomain] || {};
    const baseBooks = domainData[selectedLevel] || [];
    const extras = (extraBooks[selectedDomain] && extraBooks[selectedDomain][selectedLevel]) || [];
    return [...baseBooks, ...extras];
  }, [selectedDomain, selectedLevel, extraBooks]);

  const bookKey = (b) => `${b.title}__${b.author || b.authors || ""}`;

  const isPinned = (b) => pinned.some((p) => bookKey(p) === bookKey(b));

  const togglePin = (b) => {
    setPinned((prev) => {
      const exists = prev.some((p) => bookKey(p) === bookKey(b));
      if (exists) {
        return prev.filter((p) => bookKey(p) !== bookKey(b));
      } else {
        return [...prev, { ...b, domain: selectedDomain, level: selectedLevel }];
      }
    });
  };

  const loadBookDetail = async (book) => {
    setSelectedBook(book);
    const k = bookKey(book);
    if (detailCache[k]) return;

    setDetailLoading(true);
    // Generate realistic AI deep-dive study guide
    setTimeout(() => {
      const summary = `"${book.title}" by ${book.author || book.authors} is a foundational study in ${book.domain || selectedDomain}. It provides a rigorous exploration of core methodologies, theoretical frameworks, and key principles. Critical arguments focus on analytical reasoning, structured debate, and practical implications for examination prep and advanced scholarship.`;

      const jstor = [
        {
          title: `Analytical Review and Contemporary Re-Evaluation of ${book.title}`,
          journal: `Journal of ${book.domain || selectedDomain} Studies`,
          year: "2024",
        },
        {
          title: `Empirical Evidence and Practical Applications of ${book.title}`,
          journal: "Oxford & Cambridge Academic Review",
          year: "2023",
        },
        {
          title: `Theoretical Foundations and Comparative Critique in ${book.domain || selectedDomain}`,
          journal: "International Scholarly Quarterly",
          year: "2022",
        },
      ];

      const applications = [
        {
          title: "Examination Case Study & Analytical Frameworks",
          description: `Applying principles from ${book.title} to structure high-scoring essay arguments, case critiques, and interview responses.`,
        },
        {
          title: "Industry & Academic Deployment",
          description: `Methods from this text are actively utilized in professional practice and advanced academic research across top institutions.`,
        },
      ];

      const projects = [
        {
          title: `Critical Essay: The Evolution of Thought in ${book.title}`,
          summary: `Analyze how the author's primary hypothesis withstands modern critique and empirical scrutiny.`,
        },
        {
          title: `Comparative Seminar Project: Methodological Contrast`,
          summary: `Contrast the core framework in "${book.title}" with contemporary alternative models in ${book.domain || selectedDomain}.`,
        },
      ];

      setDetailCache((prev) => ({
        ...prev,
        [k]: { summary, jstor, applications, projects },
      }));
      setDetailLoading(false);
    }, 350);
  };

  const handleCreateNoteFromBook = (book) => {
    const k = bookKey(book);
    const guide = detailCache[k] || {};
    const jstorHtml = (guide.jstor || []).map((a) => `<li><strong>${a.title}</strong> — <em>${a.journal} (${a.year})</em></li>`).join("");
    const appsHtml = (guide.applications || []).map((app) => `<li><strong>${app.title}:</strong> ${app.description}</li>`).join("");
    const projHtml = (guide.projects || []).map((p) => `<li><strong>${p.title}:</strong> ${p.summary}</li>`).join("");

    const noteHtml = `
<h1>${book.title}</h1>
<p style="color: #5A6070; font-size: 14px;"><strong>Author:</strong> ${book.author || book.authors} | <strong>Domain:</strong> ${book.domain || selectedDomain} | <strong>Level:</strong> ${book.level || selectedLevel}</p>
<hr/>
<h2>1. Executive Summary</h2>
<p>${guide.summary || `A comprehensive analysis of "${book.title}".`}</p>
<h2>2. Academic Research & JSTOR Papers</h2>
<ul>${jstorHtml || "<li>Key academic papers and journal reviews.</li>"}</ul>
<h2>3. Real-World Applications</h2>
<ul>${appsHtml || "<li>Practical analytical frameworks and case applications.</li>"}</ul>
<h2>4. Project & Essay Prompts</h2>
<ul>${projHtml || "<li>Seminar essay topics and research prompts.</li>"}</ul>
<h2>5. Student Notes & Reflections</h2>
<p>Write your personal reflections and study notes here...</p>
    `.trim();

    if (typeof onCreateNote === "function") {
      onCreateNote(`${book.title} — Study Guide`, noteHtml);
    }
  };

  const handleGenerateBooks = () => {
    setGeneratingMore(true);
    setTimeout(() => {
      const extraList = [
        { title: `Advanced Topics in ${selectedDomain}`, author: "Academic Research Group" },
        { title: `Critical Perspectives on ${selectedDomain}`, author: "Dr. Eleanor Vance" },
        { title: `Foundations of Modern ${selectedDomain}`, author: "Prof. Arthur Pendelton" },
      ];
      setExtraBooks((prev) => {
        const dom = prev[selectedDomain] || {};
        const lvl = dom[selectedLevel] || [];
        return {
          ...prev,
          [selectedDomain]: {
            ...dom,
            [selectedLevel]: [...lvl, ...extraList],
          },
        };
      });
      setGeneratingMore(false);
    }, 600);
  };

  const renderBookCover = (book, domain) => {
    const style = getBookCoverStyle(book.title, domain || selectedDomain);
    const pinnedStatus = isPinned(book);
    return (
      <div className="SmartLibraryPage__bookCoverContainer" onClick={() => loadBookDetail(book)}>
        <div className="SmartLibraryPage__bookCover" style={{ background: style.bg, color: style.color, border: style.border }}>
          <div className="SmartLibraryPage__coverTitle">{book.title}</div>
          <div className="SmartLibraryPage__coverAuthor">{book.author || book.authors}</div>

          {pinnedStatus ? (
            <div
              className="SmartLibraryPage__bookmarkRibbon"
              title="Bookmarked to My Books (click to remove)"
              onClick={(e) => {
                e.stopPropagation();
                togglePin(book);
              }}
            >
              <svg width="10" height="12" viewBox="0 0 24 24" fill="var(--iv-btn-fg)" stroke="none" style={{ marginTop: "2px", opacity: 0.95 }}>
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
              </svg>
            </div>
          ) : (
            <button
              type="button"
              className="SmartLibraryPage__pinBtnCover"
              title="Bookmark to My Books"
              onClick={(e) => {
                e.stopPropagation();
                togglePin(book);
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
              </svg>
            </button>
          )}
        </div>
      </div>
    );
  };

  const renderPinSidebarItem = (p) => {
    const active = selectedBook && bookKey(selectedBook) === bookKey(p);
    return (
      <div
        key={bookKey(p)}
        className={`SmartLibraryPage__sidebarItemWrap ${active ? "active" : ""}`}
        onClick={() => loadBookDetail(p)}
        style={{
          "--color-primary": "var(--iv-head)",
          "--color-primary-translucent": "color-mix(in srgb, var(--iv-head) 6%, transparent)",
        }}
      >
        <div className="SmartLibraryPage__sidebarItemTitle">{p.title}</div>
        <div style={{ display: "flex", gap: 6, alignItems: "center", width: "100%" }}>
          <span style={{ fontSize: 10, padding: "2px 6px", borderRadius: 4, background: "color-mix(in srgb, var(--iv-head) 6%, transparent)", color: "var(--iv-head)", fontWeight: 600 }}>
            {p.domain || selectedDomain}
          </span>
          <button
            type="button"
            title="Remove from My Books"
            onClick={(e) => {
              e.stopPropagation();
              togglePin(p);
            }}
            style={{
              marginLeft: "auto",
              background: "none",
              border: "none",
              color: "var(--iv-muted)",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              transition: "all 0.15s ease",
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="SmartLibraryPage" style={{ minHeight: "100%", background: "var(--iv-bg)" }}>
      <div className="SmartLibraryPage__layout" style={{ minHeight: "calc(100vh - 48px)" }}>
        {/* Left Sidebar */}
        <aside className="SmartLibraryPage__sidebar" style={{ background: "var(--iv-bg)", borderRight: "1px solid var(--iv-line)" }}>
          <div className="SmartLibraryPage__sidebarHeader">
            <div className="SmartLibraryPage__sidebarTabs">
              <button
                type="button"
                className={`SmartLibraryPage__tabBtn ${view === "library" ? "SmartLibraryPage__tabBtn--active" : ""}`}
                onClick={() => setView("library")}
              >
                Browse Library
              </button>
              <button
                type="button"
                className={`SmartLibraryPage__tabBtn ${view === "mybooks" ? "SmartLibraryPage__tabBtn--active" : ""}`}
                onClick={() => setView("mybooks")}
              >
                My Books ({pinned.length})
              </button>
            </div>

            <div style={{ position: "relative", marginTop: 10 }}>
              <input
                type="text"
                placeholder="Search subjects…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="SmartLibraryPage__searchInput"
                style={{ width: "100%", boxSizing: "border-box" }}
              />
              <Search size={14} color="var(--iv-muted)" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)" }} />
            </div>
          </div>

          <div className="SmartLibraryPage__sidebarList">
            {view === "library" ? (
              filteredDomains.map((d) => (
                <button
                  key={d}
                  type="button"
                  className={`SmartLibraryPage__domainBtn ${selectedDomain === d ? "active" : ""}`}
                  onClick={() => setSelectedDomain(d)}
                >
                  {d}
                </button>
              ))
            ) : (
              <>
                {pinned.map(renderPinSidebarItem)}
                {pinned.length === 0 && (
                  <div className="SmartLibraryPage__placeholder" style={{ padding: "24px 16px", fontSize: "13px", color: "var(--iv-muted)" }}>
                    Bookmark books from the library to save them here.
                  </div>
                )}
              </>
            )}
          </div>
        </aside>

        {/* Main Panel */}
        <main className="SmartLibraryPage__main" style={{ padding: "28px 36px" }}>
          {view === "library" ? (
            <>
              {selectedDomain ? (
                <>
                  <div className="SmartLibraryPage__sectionTitleRow" style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: "12px", marginBottom: "20px" }}>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <h2 className="SmartLibraryPage__sectionTitle" style={{ fontFamily: 'var(--iv-font-head)', fontSize: 26, fontWeight: 700, margin: 0, color: "var(--iv-head)" }}>
                        {selectedDomain}
                      </h2>
                      <span style={{ fontSize: "13px", color: "var(--iv-muted)" }}>
                        ({allBooksForSelectedDomain.length} {allBooksForSelectedDomain.length === 1 ? "book" : "books"})
                      </span>
                    </div>

                    {/* Level Pills Filter */}
                    <div className="SmartLibraryPage__levelTabs" style={{ display: "flex", gap: 6, margin: 0 }}>
                      {["Easy", "Medium", "Hard"].map((lvl) => (
                        <button
                          key={lvl}
                          type="button"
                          className={`SmartLibraryPage__levelTab ${selectedLevel === lvl ? `active-${lvl}` : ""}`}
                          onClick={() => setSelectedLevel(lvl)}
                        >
                          {lvl}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* 3D Book Grid */}
                  <div className="SmartLibraryPage__bookGrid" style={{ marginBottom: 36 }}>
                    {allBooksForSelectedDomain.map((book, idx) => (
                      <div key={book.id || `${book.title}-${idx}`} className="SmartLibraryPage__bookCard">
                        {renderBookCover(book, selectedDomain)}
                      </div>
                    ))}
                  </div>

                  {/* Generate More Books */}
                  <div style={{ textAlign: "center", marginBottom: 40 }}>
                    <button
                      type="button"
                      className="SmartLibraryPage__generateBtn"
                      style={{ borderColor: "var(--iv-head)", color: "var(--iv-head)" }}
                      onClick={handleGenerateBooks}
                      disabled={generatingMore}
                    >
                      {generatingMore ? (
                        <>
                          <span className="SmartLibraryPage__spinner" style={{ width: 12, height: 12, borderWidth: 2, margin: 0 }} />
                          Generating…
                        </>
                      ) : (
                        <>✦ Generate more books</>
                      )}
                    </button>
                  </div>
                </>
              ) : (
                <div className="SmartLibraryPage__placeholder">
                  <div className="SmartLibraryPage__placeholderIcon">📚</div>
                  <div className="SmartLibraryPage__placeholderText">Select a subject from the left panel to explore.</div>
                </div>
              )}
            </>
          ) : (
            /* My Books Grid View */
            <div>
              <div className="SmartLibraryPage__sectionTitleRow" style={{ display: "flex", alignItems: "baseline", gap: "12px", marginBottom: "24px" }}>
                <h2 className="SmartLibraryPage__sectionTitle" style={{ fontFamily: 'var(--iv-font-head)', fontSize: 26, fontWeight: 700, margin: 0, color: "var(--iv-head)" }}>
                  My Bookmarked Books
                </h2>
                <span style={{ fontSize: "13px", color: "var(--iv-muted)" }}>
                  ({pinned.length} {pinned.length === 1 ? "book" : "books"})
                </span>
              </div>

              {pinned.length > 0 ? (
                <div className="SmartLibraryPage__bookGrid">
                  {pinned.map((book, idx) => (
                    <div key={book.id || `${book.title}-${idx}`} className="SmartLibraryPage__bookCard">
                      {renderBookCover(book, book.domain || selectedDomain)}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="SmartLibraryPage__placeholder" style={{ padding: "60px 0" }}>
                  <div className="SmartLibraryPage__placeholderIcon">🔖</div>
                  <div className="SmartLibraryPage__placeholderText">No books bookmarked yet. Browse the library to add books to your study list!</div>
                </div>
              )}
            </div>
          )}
        </main>
      </div>

      {/* ── Slide-Over / Modal Panel: AI Deep Dive & Study Guide ── */}
      {selectedBook && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            width: "min(520px, 92vw)",
            background: "var(--iv-bg)",
            boxShadow: "-8px 0 32px color-mix(in srgb, var(--iv-shadow) 15%, transparent)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            animation: "slideInRight 0.25s ease-out",
          }}
        >
          <div
            style={{
              padding: "18px 24px",
              borderBottom: "1px solid var(--iv-line)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "var(--iv-bg)",
            }}
          >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span style={{ fontSize: 11, padding: "3px 9px", borderRadius: 5, background: "color-mix(in srgb, var(--iv-head) 6%, transparent)", color: "var(--iv-head)", fontWeight: 600 }}>
                {selectedBook.domain || selectedDomain}
              </span>
              <span style={{ fontSize: 11, padding: "3px 9px", borderRadius: 5, background: "color-mix(in srgb, var(--iv-head) 6%, transparent)", color: "var(--iv-body)", fontWeight: 600 }}>
                {selectedBook.level || selectedLevel}
              </span>
            </div>
            <button
              type="button"
              onClick={() => setSelectedBook(null)}
              style={{
                border: "none",
                background: "transparent",
                color: "var(--iv-muted)",
                cursor: "pointer",
                padding: "6px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <X size={18} />
            </button>
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: "24px 28px" }}>
            <h2 style={{ fontFamily: 'var(--iv-font-head)', fontSize: 24, fontWeight: 700, margin: "0 0 6px 0", color: "var(--iv-body)", lineHeight: 1.25 }}>
              {selectedBook.title}
            </h2>
            <p style={{ fontSize: 14, color: "var(--iv-muted)", margin: "0 0 20px 0" }}>
              {selectedBook.author || selectedBook.authors || "Unknown Author"}
            </p>

            {/* Instant Note Generation CTA */}
            <div style={{ display: "flex", gap: 10, margin: "0 0 28px 0" }}>
              <button
                type="button"
                onClick={() => {
                  handleCreateNoteFromBook(selectedBook);
                  setSelectedBook(null);
                }}
                style={{
                  width: "100%",
                  padding: "10px 18px",
                  borderRadius: "8px",
                  border: "none",
                  background: "var(--iv-band)",
                  color: "var(--iv-on-band)",
                  fontSize: "13.5px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 8px color-mix(in srgb, var(--iv-shadow) 20%, transparent)",
                  transition: "all 0.15s ease",
                }}
              >
                <span>✦</span> Create Research Note from Book
              </button>
            </div>

            {detailLoading && !detailCache[bookKey(selectedBook)] ? (
              <div className="SmartLibraryPage__placeholder" style={{ padding: "60px 0" }}>
                <span className="SmartLibraryPage__spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
                <div className="SmartLibraryPage__placeholderText" style={{ marginTop: 12 }}>
                  Generating comprehensive study guide…
                </div>
              </div>
            ) : detailCache[bookKey(selectedBook)] ? (
              <>
                {/* Summary Section */}
                <div className="SmartLibraryPage__detailSection">
                  <div className="SmartLibraryPage__detailSectionHeader">
                    <span className="SmartLibraryPage__detailSectionIcon" style={{ color: "var(--iv-head)" }}>✦</span>
                    <h3 className="SmartLibraryPage__detailSectionTitle" style={{ color: "var(--iv-head)" }}>Summary</h3>
                  </div>
                  <p style={{ fontSize: 14, lineHeight: 1.7, color: "var(--iv-head)", margin: 0 }}>
                    {detailCache[bookKey(selectedBook)].summary}
                  </p>
                </div>

                {/* JSTOR Articles */}
                <div className="SmartLibraryPage__detailSection">
                  <div className="SmartLibraryPage__detailSectionHeader">
                    <span className="SmartLibraryPage__detailSectionIcon" style={{ color: "var(--iv-head)" }}>◎</span>
                    <h3 className="SmartLibraryPage__detailSectionTitle" style={{ color: "var(--iv-head)" }}>Academic Articles (JSTOR)</h3>
                  </div>
                  {(detailCache[bookKey(selectedBook)].jstor || []).map((art, idx) => (
                    <div key={idx} className="SmartLibraryPage__detailCard">
                      <div className="SmartLibraryPage__detailCardTitle">{art.title}</div>
                      <div className="SmartLibraryPage__detailCardMeta">{art.journal} {art.year ? `· ${art.year}` : ""}</div>
                    </div>
                  ))}
                </div>

                {/* Applications */}
                <div className="SmartLibraryPage__detailSection">
                  <div className="SmartLibraryPage__detailSectionHeader">
                    <span className="SmartLibraryPage__detailSectionIcon" style={{ color: "var(--iv-head)" }}>◈</span>
                    <h3 className="SmartLibraryPage__detailSectionTitle" style={{ color: "var(--iv-head)" }}>Real-World Applications</h3>
                  </div>
                  {(detailCache[bookKey(selectedBook)].applications || []).map((appItem, idx) => (
                    <div key={idx} className="SmartLibraryPage__detailCard">
                      <div className="SmartLibraryPage__detailCardTitle">{appItem.title}</div>
                      <p className="SmartLibraryPage__detailCardText" style={{ margin: 0 }}>{appItem.description}</p>
                    </div>
                  ))}
                </div>

                {/* Project Ideas */}
                <div className="SmartLibraryPage__detailSection">
                  <div className="SmartLibraryPage__detailSectionHeader">
                    <span className="SmartLibraryPage__detailSectionIcon" style={{ color: "var(--iv-head)" }}>◉</span>
                    <h3 className="SmartLibraryPage__detailSectionTitle" style={{ color: "var(--iv-head)" }}>Project & Essay Ideas</h3>
                  </div>
                  {(detailCache[bookKey(selectedBook)].projects || []).map((proj, idx) => (
                    <div key={idx} className="SmartLibraryPage__detailCard">
                      <div className="SmartLibraryPage__detailCardTitle">{proj.title}</div>
                      <p className="SmartLibraryPage__detailCardText" style={{ margin: 0 }}>{proj.summary}</p>
                    </div>
                  ))}
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}
